'use strict';

import React, { Component } from 'react';
import JsonFormSchema from '../../../commonModules/interface/JsonFormSchema';

// import Form from "react-jsonschema-form";

class RegisterProspectForm extends Component{

    state = {
        schemaID: this.props.schemaID,
        jsonSchema: {},
        uiSchema: {},
        initFormData:{},
    }
    shouldComponentUpdate= (nextProps, nextState) => {
        console.log('[DEBUG],RegisterProspectForm,shouldComponentUpdate, Next Init Form Data,',nextProps.initFormData, ' and ', nextProps.schemaID);
        if (nextProps.schemaID != this.state.schemaID){
            if (nextProps.initFormData != ""){
                this.setState({schemaID:nextProps.schemaID,initFormData: nextProps.initFormData});
            }else{
                this.setState({schemaID:nextProps.schemaID });
            }
            const rep = this.updateSchema(nextProps.schemaID);
            console.log('[INFO], register Prospects, shouldComponentUpdate, ok=======+++++');
            return true
        }else{
            if (nextState.jsonSchema != this.state.jsonSchema){
                console.log('[INFO], register Prospects, shouldComponentUpdate, JSON +++++');
                return true;
            }
            return false
        }
    }
    updateSchema= async(schemaID) => {
        //Get Schema to be trasnform from Prospect to Client
        console.log('[INFO], Request for schemaID : ', schemaID);
        try {
            const response = await fetch('/schema/get?idSchema='+schemaID, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Requested-With': 'XMLHttpRequest',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log('[INFO], Request for schemaID , response ==>  ',resp);
            let jsonrep = {};
            let uirep = {};

            try {
                uirep = JSON.parse(resp.uiSchema);
            }catch(e){
                uirep = resp.uiSchema ;
            }
            try{
                jsonrep = JSON.parse(resp.jsonSchema);
            }catch(e){
                jsonrep = resp.jsonSchema ;
            }

            this.setState({jsonSchema: jsonrep,uiSchema: uirep});
        } catch (err) {
            console.log("[ERROR], getting prospect data",err)
        }
    }
    onSubmit(form){
        console.log("Data submitted: ")
        console.log({form});
        this.props.onValidation(form);
    }
    handleOnChange({ formData }) {
        this.setState({ formData });
    }
    adaptedJsonSchema= (initForm,jsonForm) => {
        console.log("[DBG],registerProspects Lists,Adapted adaptedJsonSchema",initForm, ' and ', jsonForm);
        let newForm = {};
        if (initForm === undefined || typeof initForm == 'undefined'){
            console.log("[ERROR],registerProspects Lists,init Form",initForm);
            return newForm;
        }
        try{
            Object.keys(jsonForm.properties).forEach(function(keyOne) {
                //console.log('[DBG1],',keyOne);
                Object.keys(initForm).forEach(function(key) {
                    //console.log('[DBG2],',keyOne,',vs,',key,',');
                    if(key == keyOne) { 
                        //console.log("do something ");
                        newForm[key] =initForm[keyOne];
                }
                });
            });
            return newForm;
        }catch(e){
            console.log("[ERROR],registerProspects Lists,Trasnform form",e);
            return {};
        }
       
    }
    handleOnChange({ formData }) {
        console.log("[DEBUG], Update",{ formData } );
      this.setState({ initFormData: formData });
    }
    render() {
        console.log("[DEBUG], Validation, New Info to enter",this.state);
        if (this.props.schemaID === ""|| this.state.jsonSchema === {} ){
            return (
                <div>
                </div>
            );
        } else {
            // Check initFormDataMatch with
            let initForm = this.adaptedJsonSchema(this.state.initFormData, this.state.jsonSchema);
            console.log("[DEBUG], Transform Json Schema,",initForm);
            return (
                <div>
                    <JsonFormSchema
                        className="bootgrid-header container-fluid"
                        schema={this.state.jsonSchema}
                        uiSchema={this.state.uiSchema} 
                        formData={initForm}
                        onChange={args => this.handleOnChange(args)} 
                        onSubmit={ args => this.onSubmit(args) }
                    />
                </div>
            );
        }

    }
};

export default RegisterProspectForm